import './product-additionaly.component.pug'
import './product-additionaly.component.scss'
import { Swiper } from 'swiper'

const selectors = {
  poster: '.product-additionaly__posters.swiper-container',
  content: '.product-additionaly__content.swiper-container',
  buttons: '.product-additionaly-button',
  nav: '.product-additionaly__nav'
}

const sections = document.querySelectorAll('.product-additionaly')

sections.forEach((root) => {
  let swiperPosterInstance = null
  let swiperContentInstance = null
  const swiperPosterElement = root.querySelector(selectors.poster)
  const swiperContentElement = root.querySelector(selectors.content)
  const navButtons = root.querySelectorAll(selectors.buttons)
  const navContainer = root.querySelector(selectors.nav)

  const changeState = (swiperInstance) => {
    if (!swiperInstance) {
      swiperInstance = swiperPosterInstance
    }
    const targetIndex = swiperInstance.activeIndex
    const button = navButtons[targetIndex]
    navButtons.forEach((button) => button.classList.remove('active'))
    button.classList.add('active')
    swiperContentInstance.slideTo(targetIndex)

    navContainer.scrollTo({
      left: button.getBoundingClientRect().left - 26
    })
  }
  const changeStateByContent = (swiperInstance) => {
    if (!swiperInstance) {
      swiperInstance = swiperContentInstance
    }
    const targetIndex = swiperInstance.activeIndex
    swiperPosterInstance.slideTo(targetIndex)
  }

  root.addEventListener('click', ({ target }) => {
    const targetButton = target.closest(selectors.buttons)
    if (targetButton) {
      const index = Array.from(navButtons).findIndex(
        (button) => button === targetButton
      )
      if (index >= 0) {
        swiperPosterInstance.slideTo(index)
      }
    }
  })

  if (swiperContentElement) {
    swiperContentInstance = new Swiper(swiperContentElement, {
      slidesPerView: 1,
      simulateTouch: false,
      speed: 800,
      spaceBetween: 20,
      on: {
        slideChange: changeStateByContent
      }
      /*allowTouchMove: false*/
    })
  }
  if (swiperPosterElement) {
    swiperPosterInstance = new Swiper(swiperPosterElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      on: {
        afterInit: changeState,
        slideChange: changeState
      },
      speed: 800
    })
  }
})
